var storefrontApp = angular.module('storefrontApp');

storefrontApp.component('vcCreditCard', {
    templateUrl: "themes/assets/js/common-components/creditCard.tpl.html",
    require: {
        checkoutStep: '?^vcCheckoutWizardStep'
    },
    bindings: {
        card: '=',
        validationContainer: '=',
        authorizeNetCustomerProfile: '<',
        defaultPaymentProfileId: '<',
        onPaymentProfileChangedMethod: '&',
        readOnly: '='
    },
    controller: ['$scope', '$filter', function ($scope, $filter) {
        var ctrl = this;
        
        ctrl.unlockEditing = unlockEditing;
        ctrl.showProfileDropdown = false;
        ctrl.showCardForm = true;

        if (!ctrl.card) {
            ctrl.card = {};
        }

        this.$onInit = function () {
            if(ctrl.validationContainer)
                ctrl.validationContainer.addComponent(this);
            if (ctrl.checkoutStep)
                ctrl.checkoutStep.addComponent(this);            
        };

        this.$onChanges = function (changes) {
            if (changes.authorizeNetCustomerProfile) {
                ctrl.authorizeNetCustomerProfile = angular.copy(changes.authorizeNetCustomerProfile.currentValue);
                if (ctrl.authorizeNetCustomerProfile && ctrl.authorizeNetCustomerProfile.paymentProfiles.length > 0) {
                    ctrl.showProfileDropdown = true;
                    ctrl.showCardForm = false;
                    
                    ctrl.card.paymentProfile = _.find(ctrl.authorizeNetCustomerProfile.paymentProfiles, function (pp) { return pp.id == ctrl.defaultPaymentProfileId; });
                    if (!ctrl.card.paymentProfile) {
                        ctrl.card.paymentProfile = ctrl.authorizeNetCustomerProfile.paymentProfiles[0];
                    }

                    if (ctrl.onPaymentProfileChangedMethod) {
                        ctrl.onPaymentProfileChangedMethod({ paymentProfile: ctrl.card.paymentProfile });
                    }
                }                
            }
        };

        this.$onDestroy = function () {
            if (ctrl.validationContainer)
                ctrl.validationContainer.removeComponent(this);
            if (ctrl.checkoutStep)
                ctrl.checkoutStep.removeComponent(this);
        };

        ctrl.validate = function () {
            if (ctrl.readOnly) {
                return true;
            }
            else {
                ctrl.form.$setSubmitted();
                return !ctrl.form.$invalid;
            }
        };

        ctrl.paymentProfileChanged = function () {
            if (!ctrl.card.paymentProfile) {
                ctrl.showCardForm = true;
            } else {
                ctrl.showCardForm = false;
            }
            
            if (ctrl.onPaymentProfileChangedMethod) {
                ctrl.onPaymentProfileChangedMethod({ paymentProfile: ctrl.card.paymentProfile });
            }
        };

               
        function unlockEditing() { 
            ctrl.readOnly = false; 
            ctrl.card.bankCardMonth = '';
            ctrl.card.bankCardYear = '';
        };

    }]
});
